import { useState } from 'react'

import { Option } from 'components/ui/Search/SearchOption'
import Suggests from 'components/ui/Suggests/Suggests'
import {
  allWarehouseTypes,
  Warehouse,
  WarehouseAPI,
  WarehouseType,
} from 'services/warehouse-containers/warehouse'

type Props = {
  title?: string
  searchForTypes?: WarehouseType[]
  onSelect: (warehouse: Warehouse) => void
}

export const WarehouseSearch = ({
  title = 'Выберите склад',
  onSelect,
  searchForTypes = allWarehouseTypes,
}: Props) => {
  const [values, setValues] = useState<Warehouse[]>([])

  const handleOnSelect = (option?: Option<Warehouse>): void => onSelect?.(option?.element)

  const searchFunction = async (input: string): Promise<void> => {
    if (input === '') {
      setValues([])
      return
    }

    const result = await WarehouseAPI.searchByPattern({
      pattern: input,
      warehouseTypes: searchForTypes,
    })
    setValues(result)
  }

  const suggestOption = values?.map((el: Warehouse) => ({ name: el.name, element: el }))

  return (
    <Suggests
      placeholder={title}
      options={suggestOption}
      onSearch={searchFunction}
      onSelect={handleOnSelect}
    ></Suggests>
  )
}
